import AppGeneralPopup from './app_general_popup';

export default AppGeneralPopup;
